import axios from 'axios';

export default {
  state: {
    order: {},
    loading: false,
    error: null,
    orderLoaded: false,
    orderLoading: false,
    success: 'N',
    redirect: ''
  },
  mutations: {
    SET_ORDER(state, order) {
      state.order = order.data;
      state.orderLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_ORDER_SUCCESS(state, data) {
      state.redirect = data.redirect;
      state.success = data.success;
    },
    SET_ORDER_LOADING(state, status) {
      state.orderLoading = status;
    },
    SET_ORDER_ERROR(state, error) {
      state.orderError = error;
    },
    UNSET_ORDER(state) {
      state.orderLoaded = false;
      state.orderLoading = false;
      state.order = [];
    },
  },
  actions: {
    async fetchOrder({ commit, state }) {
      commit('UNSET_ORDER');
      try {
        commit('SET_ORDER_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/order/fields/');
        commit('SET_ORDER', response.data);
        commit('SET_ORDER_ERROR', null);
      } catch (error) {
        commit('SET_ORDER_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching order:', error);
      } finally {
        commit('SET_ORDER_LOADING', false);
      }
    },
    async reloadOrder({ commit, state }, data) {
      //commit('UNSET_ORDER');
      try {
        commit('SET_ORDER_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/order/fields/',
            data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        commit('SET_ORDER', response.data);
        commit('SET_ORDER_ERROR', null);
      } catch (error) {
        commit('SET_ORDER_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching order:', error);
      } finally {
        commit('SET_ORDER_LOADING', false);
      }
    },
    async saveOrder({ commit, state, dispatch }, data) {
      //commit('UNSET_ORDER');
      try {
        commit('SET_ORDER_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/order/',
            data, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
       dispatch('fetchCounterData', true);
        if (response.data.success == 'Y') {
          //dispatch('fetchCounterData', true);
          commit('SET_ORDER_SUCCESS', response.data);
          if (response.data.data) {
            commit('SET_ORDER', response.data);
          }
          commit('SET_ORDER_ERROR', null);
        }
        else {
          let serverError= '';
          for (let i in response.data.data.ERROR) {
             serverError += response.data.data.ERROR[i]+"<br>";
          }
          commit('SET_ORDER_ERROR', serverError);
        }

      } catch (error) {
        dispatch('fetchCounterData', true);
        commit('SET_ORDER_ERROR', error.message || 'Ошибка при загрузке категорий');
      } finally {
        commit('SET_ORDER_LOADING', false);
      }

    }
  },
  getters: {
    order: state => state.order,
    orderLoading: state => state.orderLoading,
    orderError: state => state.orderError,
    orderLoaded: state => state.orderLoaded,
    success: state => state.success,
    redirect: state => state.redirect
  }
}